import { useQueryClient } from '@tanstack/react-query'
import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface IUpdateProductParams {
  productId: string
  name: string
  productTypeId: string
  publicationGroupId: string
  legalId: string
  site: string
}

interface IUpdateProductResponse {
  id: string
  name: string
  productTypeId: string
  publicationGroupId: string
  legalId: string
  site: string
}

async function fetchUpdateProduct(path: string, body: IUpdateProductParams) {
  const { data } = await apiPost<IUpdateProductParams, IUpdateProductResponse>({ path, body })

  return data
}

export const useUpdateProduct = (options?: {
  onSuccess?: (data: IUpdateProductResponse) => void
  onError?: (error: Error) => void
}) => {
  const queryClient = useQueryClient()
  const path = API_ROUTES.PRODUCT_UPDATE
  const mutationFn = (url: string, body: IUpdateProductParams) => fetchUpdateProduct(url, body)

  const mutationFunc = useMutationHook({
    path,
    mutationKey: [path],
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.PRODUCTS],
      })
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.PRODUCT_GET, data.id],
      })
      options?.onSuccess?.(data)
    },
    onError: options?.onError,
  })

  return mutationFunc
}
